(function(){
  
  window.addEventListener('error', function(event) {
      if (
        event.message &&
        /this\.closest\(['"]\.image['"]\)\.classList/.test(event.message)
      ) {
          event.stopImmediatePropagation();
          event.preventDefault();
      }
  }, true);


  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('img.image__img').forEach(function(img) {
      if (!img.hasAttribute('data-safe-lazy')) { // 중복 방지
        img.setAttribute('data-safe-lazy', '1');
        img.addEventListener('load', function(e) {
          const wrapper = e.target.closest && e.target.closest('.image');
          if (wrapper && !wrapper.classList.contains('loaded')) {
            wrapper.classList.add('loaded');
          }
        });
      }
    });
  });


  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function(){
      document.querySelectorAll('img.image__img:not([data-safe-lazy])').forEach(function(img) {
        img.setAttribute('data-safe-lazy', '1');
        img.addEventListener('load', function(e) {
          const wrapper = e.target.closest && e.target.closest('.image');
          if (wrapper && !wrapper.classList.contains('loaded')) {
            wrapper.classList.add('loaded');
          }
        });
      });
    });
  }

})();